import { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import classNames from 'clsx';
import get from 'lodash/get';
import { requiredField } from 'src/common/utils/form/validation';
import { SUBSCRIBE_PAYMENT_FORM_BILLING_COUNTRY } from 'src/common/constants/localizations/subscription';
import Label from '../../shared/form/Label';
import Select from '../../shared/form/Select';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';
import css from '../payment.module.scss';

class LocationField extends Component {
  static propTypes = {
    form: PropTypes.object.isRequired,
    formId: PropTypes.string.isRequired,
    locationOptions: PropTypes.array,
    selectLocationOption: PropTypes.func.isRequired,
    disableAll: PropTypes.bool.isRequired,
  };

  static contextType = LocationAndLocalizationContext;

  componentDidUpdate(prevProps) {
    const nextLocationIndex = this.getLocationIndex(this.props);
    const prevLocationIndex = this.getLocationIndex(prevProps);

    if (nextLocationIndex !== prevLocationIndex && nextLocationIndex >= 0) {
      this.props.selectLocationOption(nextLocationIndex);
    }
  }

  getLocationIndex = (props) => get(props, 'form.values.location');

  render() {
    const { locationOptions, disableAll, formId } = this.props;
    if (!locationOptions) {
      return null;
    }
    return (
      <div>
        <Label labelText="Location" dataTestId="locationLabel" isRequired />
        <div className="row">
          <div
            data-testid="locationContainer"
            className={classNames('col-xs-12', css.column)}
          >
            <Field
              component={Select}
              tabIndex={11}
              id={`${formId}Location`}
              dataTestId="location"
              name="location"
              defaultOptionName={this.context.getLocalizedText(
                SUBSCRIBE_PAYMENT_FORM_BILLING_COUNTRY,
              )}
              options={locationOptions}
              validate={requiredField}
              inlineErrors
              disabled={disableAll}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default LocationField;
